import { IReSendVerificationCodeDto, IVerificationCodeDto } from '@app-types/verificationCode';
import axios from './axios';

const check = (data: IVerificationCodeDto) => axios.get(`/verification-codes/${data.codeValue}`, { params: data.params });

const reSend = (data: IReSendVerificationCodeDto) => axios.post('/verification-codes/re-send', data);

export default { check, reSend };
